import React from "react";
import styled from "styled-components";
import { motion } from "motion/react";
import {
  COMMON,
  BORDER,
  LAYOUT,
  POSITION,
  type TypeSystemCommonProps,
  type TypeSystemBorderProps,
  type TypeSystemLayoutProps,
  type TypeSystemPositionProps,
} from "@sproutsocial/seeds-react-system-props";

interface StyledOverlayProps
  extends TypeSystemCommonProps,
    TypeSystemBorderProps,
    TypeSystemLayoutProps,
    TypeSystemPositionProps {
  allowInteraction?: boolean;
}

// Styled motion.div for the overlay wrapper
export const StyledMotionOverlay = styled(motion.div)<{ $zIndex?: number }>`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: ${(props) => props.$zIndex ?? 6};
`;

export const StyledOverlay = styled.div.withConfig({
  shouldForwardProp: (prop) => !["allowInteraction"].includes(prop),
})<StyledOverlayProps>`
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.colors.overlay.background.base};

  /* Allow clicking through overlay when modal is draggable */
  ${(props) =>
    props.allowInteraction &&
    `
    pointer-events: none;
  `}

  ${COMMON}
  ${BORDER}
  ${LAYOUT}
  ${POSITION}
`;

StyledOverlay.displayName = "ModalOverlay";
